module.exports = __webpack_public_path__ + "static/img/logo-rgb-web.e8efa1b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-rgb-web.jpg
// module id = 187
// module chunks = 1